/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConversationalAgentProtocolEnum } from './ConversationalAgentProtocolEnum';
import {
  ConversationalAgentProtocolEnumFromJSON,
  ConversationalAgentProtocolEnumFromJSONTyped,
  ConversationalAgentProtocolEnumToJSON,
} from './ConversationalAgentProtocolEnum';
import type { CredentialRead } from './CredentialRead';
import { CredentialReadFromJSON, CredentialReadFromJSONTyped, CredentialReadToJSON } from './CredentialRead';

/**
 *
 * @export
 * @interface PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina
 */
export interface PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina {
  /**
   *
   * @type {ConversationalAgentProtocolEnum}
   * @memberof PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina
   */
  protocol: ConversationalAgentProtocolEnum;
  /**
   *
   * @type {number}
   * @memberof PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina
   */
  readonly id: number;
  /**
   *
   * @type {string}
   * @memberof PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina
   */
  name?: string | null;
  /**
   *
   * @type {CredentialRead}
   * @memberof PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina
   */
  readonly credential: CredentialRead;
  /**
   *
   * @type {Date}
   * @memberof PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina
   */
  timestamp?: Date;
  /**
   *
   * @type {string}
   * @memberof PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina
   */
  environment: string;
  /**
   *
   * @type {string}
   * @memberof PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina
   */
  tenant: string;
  /**
   *
   * @type {string}
   * @memberof PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina
   */
  region?: string;
  /**
   *
   * @type {string}
   * @memberof PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina
   */
  domain?: string;
}

/**
 * Check if a given object implements the PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina interface.
 */
export function instanceOfPatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina(
  value: object,
): value is PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina {
  if (!('protocol' in value) || value['protocol'] === undefined) return false;
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('credential' in value) || value['credential'] === undefined) return false;
  if (!('environment' in value) || value['environment'] === undefined) return false;
  if (!('tenant' in value) || value['tenant'] === undefined) return false;
  return true;
}

export function PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelinaFromJSON(
  json: any,
): PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina {
  return PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelinaFromJSONTyped(json, false);
}

export function PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelinaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina {
  if (json == null) {
    return json;
  }
  return {
    protocol: ConversationalAgentProtocolEnumFromJSON(json['protocol']),
    id: json['id'],
    name: json['name'] == null ? undefined : json['name'],
    credential: CredentialReadFromJSON(json['credential']),
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
    environment: json['environment'],
    tenant: json['tenant'],
    region: json['region'] == null ? undefined : json['region'],
    domain: json['domain'] == null ? undefined : json['domain'],
  };
}

export function PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelinaToJSON(
  value?: Omit<
    PatchedConversationalAgentInferencerPolymorphicConversationalAgentInferencerCelina,
    'id' | 'credential'
  > | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    protocol: ConversationalAgentProtocolEnumToJSON(value['protocol']),
    name: value['name'],
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
    environment: value['environment'],
    tenant: value['tenant'],
    region: value['region'],
    domain: value['domain'],
  };
}
